export default {
  /** Primary Containers and Banners */
  default: '14px' as const,
  /** Secondary Contrainers and Banners */
  rounded: '50px' as const,
  smooth: '8px' as const,
  /** Tertiary Containers */
  smaller: '4px' as const
};
